import {
  UpdateUserRequestDto,
  CreateUserRequestDto,
  UserDto,
  FilterItemDto,
  UserDtoQueryResultDto,
} from 'models/dtoTypes';
import { getUserApi } from 'services';
import { handleError } from './openapiClient';
import { signInAuthProvider } from 'auth';
import CurrentUser from 'auth/currentUser';
import { IPublicClientApplication } from '@azure/msal-browser';

export const CreateUser = async (requestBody: CreateUserRequestDto): Promise<string> => {
  const client = await getUserApi();
  const response = await client.createUser(requestBody);
  return response.data;
};

export const UpdateUser = async (
  id: string,
  requestBody: UpdateUserRequestDto,
): Promise<UserDto> => {
  const client = await getUserApi();
  const response = await client.updateUser(id, requestBody);
  return response.data;
};

export const DisableUser = async (userId: string): Promise<UserDto> => {
  const client = await getUserApi();
  const response = await client.disableTfpUser(userId);
  return response.data;
};

export const EnableUser = async (userId: string): Promise<UserDto> => {
  const client = await getUserApi();
  const response = await client.enableTfpUser(userId);
  return response.data;
};

export const GetCurrent = async () => {
  try {
    const client = await getUserApi();
    const response = await client.getCurrent();
    return response?.data;
  } catch (e) {
    handleError(e);
  }
};
export const GetCurrentOrganisation = async () => {
  try {
    const client = await getUserApi();
    const response = await client.getCurrentOrganisation();
    return response?.data || undefined;
  } catch (e) {
    handleError(e);
  }
};

export const GetCurrentCompany = async () => {
  const client = await getUserApi();
  const response = await client.getCurrentCompany();
  return response.data;
};

export const GetUsers = async (options: {
  pageIndex: number;
  fullTextSearch?: string;
  filters?: FilterItemDto[];
  sortColumn?: string;
  isDesc?: boolean;
}): Promise<UserDtoQueryResultDto> => {
  const client = await getUserApi();
  const response = await client.getUsers(options);
  return response.data || [];
};

export const GetUser = async (id: string): Promise<UserDto> => {
  const client = await getUserApi();
  const response = await client.getUser(id);
  return response.data;
};

export const Logout = (instance: IPublicClientApplication) => {
  instance
    .logoutRedirect()
    .then(() => {
      signInAuthProvider.logout();
      CurrentUser.getInstance().clearSession();
    })
    .catch((e) => {
      console.error(e);
    });
};
